import environment from "@/modules/environment";
import { getVideoFiles } from "./getVideoFiles";

type Props = {
  src: string;
  alt?: string;
  className?: string;
  videoProps?: JSX.IntrinsicElements["video"];
};

export default function AppImage({ src, className, videoProps }: Props) {
  const videoData = getVideoFiles()[`/src/assets/${environment.appName}/${src}`];

  return <video className={className} src={videoData.default} {...videoProps} muted />;
}
